import { graphqlbase } from '../../../_graph/_graphqlbase'

class EventSync extends graphqlbase {
  constructor (filter) {
    super(null)
    this.use_loader = false

    this.query = `query GET_EVENTS {
  events(
    first: 50,
    where: {
      metaQuery: {
        relation: AND
        metaArray: [
          {
            key: "event_date_start",
            value: "`+ filter[0] +`"
            compare: GREATER_THAN_OR_EQUAL_TO
          },
          {
            key: "event_date_start",
            value: "`+ filter[1] +`"
            compare: LESS_THAN_OR_EQUAL_TO
          }
        ]
      }
  \t}
  ) {
    nodes {
       eventId
       url
       teaser
       subtitle
       eventTitle
       title
       dateStart
       dateEnd
       timeStart
       timeEnd
       image
       eventsTopic {
        name
        url
       }
       eventsType {
        name
        url
       }
       eventsSeries {
        name
        url
       }
       bookedOut
       closed
    }
  }
}
`
 }

  render (data) {
    return data
  }
}

export { EventSync };

/*
(where: {date_start:"1" })

filter: {
          conditions: [
            { operator: BETWEEN, field:"field_event_date", value: ["`+ filter[0] +`", "`+ filter[1] +`"]}
           ]
        }
 */
